<template>
  <div class="panel"><div class="toolbar"><div><h2>审批详情</h2><span class="muted">审批快照与业务数据分离保存</span></div><span class="status">等待配置</span></div>
    <el-timeline><el-timeline-item timestamp="申请人" type="primary">提交申请</el-timeline-item><el-timeline-item timestamp="审批节点">按组织、角色和数据范围选人</el-timeline-item><el-timeline-item timestamp="同步">审批完成后通过 Outbox 推送外部系统</el-timeline-item></el-timeline>
  </div>
</template>
